export const SCRIPT_SRC = "https://static.zdassets.com/ekr/snippet.js";

export const getDefaultSettings = () => {
  return "window.zESettings = { webWidget: { chat: { connectOnPageLoad: false }}};";
};

export const ZENDESK_DEFAULT_ZINDEX = 99999;
